import { render, staticRenderFns } from "./project-dynamic.vue?vue&type=template&id=8fecfb04&scoped=true&"
import script from "./project-dynamic.vue?vue&type=script&lang=js&"
export * from "./project-dynamic.vue?vue&type=script&lang=js&"
import style0 from "./project-dynamic.vue?vue&type=style&index=0&id=8fecfb04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fecfb04",
  null
  
)

export default component.exports